module.exports = __webpack_public_path__ + "components/weather-icon/static/nightcloud-0230646cfa89e4b0c93db49a001d1a64.webp";